import { updatePoliceLatLong } from "@/graphql/mutations.js";
import { API, graphqlOperation } from "aws-amplify";
// import { GetNearCarDetails } from "@/mixins/Methods/GetCarNearDetails.js";

export const GetAllNearMotorist = {
  mixins: [],
  data() {
    return {
      GetAllMotoristsList: [],
      overlay: false,
      user_type: "",
      ChatsList: {},
    };
  },
  methods: {
    async GetAllNearMotoristMethod(Latitude, Longitude, location) {
      try {
        this.overlay = false;
        var inputParams = {
          user_id: this.$store.getters.get_current_user_details.user_id,
          police_latitude: Latitude,
          police_longitude: Longitude,
        };

        let result = await API.graphql(
          graphqlOperation(updatePoliceLatLong, {
            input: inputParams,
          })
        );
        let ResultObject = JSON.parse(result.data.updatePoliceLatLong);
        if (location != "NearByLocation") {
          if (ResultObject.status == 200) {
            this.SnackBarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "green",
              Top: true,
              SnackbarText: "Location Updated",
            };
          }
        }
        this.$store.commit("SET_SUBSCRIPTION_STATUS", true);
        this.$store.commit("SET_CURRENT_LOCATION", false);
        // let MotoristsNearArray = JSON.parse(
        //   result.data.updatePoliceLatLong
        // ).cleanResponse;
        // this.subscribeToNewRequest();
        // if (MotoristsNearArray.length > 0) {
        //   for (let i = 0; i < MotoristsNearArray.length; i++) {
        //     MotoristsNearArray[i].profile_pic_url =
        //       await this.GenerateS3URLMethods(
        //         MotoristsNearArray[i].profile_pic_url
        //       );
        //   }
        //   this.GetAllMotoristsList = MotoristsNearArray;
        //   this.AllCarDetails = true;
        // }
        // if (MotoristsNearArray.length == 0) {
        //   this.SnackBarComponent = {
        //     SnackbarVmodel: true,
        //     SnackbarColor: "red",
        //     Top: true,
        //     SnackbarText: "No Nearby Motorists",
        //   };
        // }

        this.overlay = false;
        // console.log("Chats", this.GetAllMotoristsList);
      } catch (error) {
        console.log("Check error", error);
        this.overlay = false;
      }
    },
  },
};
